export const validateWorkflowJson = (workflow, cardTypes) => {
  if (!workflow || typeof workflow !== 'object' || Array.isArray(workflow)) {
    return 'Workflow must be a JSON object.'
  }

  if (typeof workflow.name !== 'string' || !workflow.name.trim()) {
    return 'Workflow is missing a valid "name" field.'
  }

  if (!Array.isArray(workflow.domainEvents)) {
    return 'Workflow is missing a valid "domainEvents" array.'
  }

  for (let i = 0; i < workflow.domainEvents.length; i++) {
    const event = workflow.domainEvents[i]
    if (!event || typeof event !== 'object') {
      return `domainEvents[${i}] is not a valid object.`
    }
    if (typeof event.id !== 'string' || !event.id.trim()) {
      return `domainEvents[${i}] is missing a valid "id".`
    }
    if (typeof event.type !== 'string' || !event.type.trim()) {
      return `domainEvents[${i}] is missing a valid "type".`
    }
    if (event.cards !== undefined && event.cards !== null) {
      if (!Array.isArray(event.cards)) {
        return `domainEvents[${i}].cards must be an array.`
      }
      for (let j = 0; j < event.cards.length; j++) {
        const card = event.cards[j]
        if (!card || typeof card !== 'object') {
          return `domainEvents[${i}].cards[${j}] is not a valid object.`
        }
        if (typeof card.id !== 'string' || !card.id.trim()) {
          return `domainEvents[${i}].cards[${j}] is missing a valid "id".`
        }
      }
    }
  }

  if (workflow.lanes !== undefined && workflow.lanes !== null) {
    if (!Array.isArray(workflow.lanes)) {
      return 'Workflow "lanes" must be an array.'
    }
    for (let i = 0; i < workflow.lanes.length; i++) {
      const lane = workflow.lanes[i]
      if (!lane || typeof lane !== 'object') {
        return `lanes[${i}] is not a valid object.`
      }
      if (typeof lane.id !== 'string' || !lane.id.trim()) {
        return `lanes[${i}] is missing a valid "id".`
      }
    }
  }

  if (workflow.schemas !== undefined && workflow.schemas !== null) {
    if (!Array.isArray(workflow.schemas)) {
      return 'Workflow "schemas" must be an array.'
    }
    for (let i = 0; i < workflow.schemas.length; i++) {
      const schema = workflow.schemas[i]
      if (!schema || typeof schema !== 'object') {
        return `schemas[${i}] is not a valid object.`
      }
      if (typeof schema.id !== 'string' || !schema.id.trim()) {
        return `schemas[${i}] is missing a valid "id".`
      }
      if (typeof schema.name !== 'string' || !schema.name.trim()) {
        return `schemas[${i}] is missing a valid "name".`
      }
      if (schema.fields !== undefined && schema.fields !== null) {
        if (!Array.isArray(schema.fields)) {
          return `schemas[${i}].fields must be an array.`
        }
        for (let j = 0; j < schema.fields.length; j++) {
          const field = schema.fields[j]
          if (!field || typeof field !== 'object') {
            return `schemas[${i}].fields[${j}] is not a valid object.`
          }
          if (typeof field.name !== 'string' || !field.name.trim()) {
            return `schemas[${i}].fields[${j}] is missing a valid "name".`
          }
        }
      }
    }
  }

  if (workflow.groups !== undefined && workflow.groups !== null) {
    if (!Array.isArray(workflow.groups)) {
      return 'Workflow "groups" must be an array.'
    }
    for (let i = 0; i < workflow.groups.length; i++) {
      const group = workflow.groups[i]
      if (!group || typeof group !== 'object') {
        return `groups[${i}] is not a valid object.`
      }
      if (typeof group.id !== 'string' || !group.id.trim()) {
        return `groups[${i}] is missing a valid "id".`
      }
    }
  }

  if (workflow.releases !== undefined && workflow.releases !== null) {
    if (!Array.isArray(workflow.releases)) {
      return 'Workflow "releases" must be an array.'
    }
    for (let i = 0; i < workflow.releases.length; i++) {
      const release = workflow.releases[i]
      if (!release || typeof release !== 'object') {
        return `releases[${i}] is not a valid object.`
      }
    }
  }

  if (workflow.boundedContexts !== undefined && workflow.boundedContexts !== null) {
    if (!Array.isArray(workflow.boundedContexts)) {
      return 'Workflow "boundedContexts" must be an array.'
    }
    for (let i = 0; i < workflow.boundedContexts.length; i++) {
      const bc = workflow.boundedContexts[i]
      if (!bc || typeof bc !== 'object') {
        return `boundedContexts[${i}] is not a valid object.`
      }
      if (typeof bc.id !== 'string' || !bc.id.trim()) {
        return `boundedContexts[${i}] is missing a valid "id".`
      }
    }
  }

  if (cardTypes !== undefined && cardTypes !== null) {
    if (!Array.isArray(cardTypes)) {
      return 'cardTypes must be an array.'
    }
    for (let i = 0; i < cardTypes.length; i++) {
      const ct = cardTypes[i]
      if (!ct || typeof ct !== 'object') {
        return `cardTypes[${i}] is not a valid object.`
      }
      if (typeof ct.id !== 'string' || !ct.id.trim()) {
        return `cardTypes[${i}] is missing a valid "id".`
      }
      if (typeof ct.title !== 'string' || !ct.title.trim()) {
        return `cardTypes[${i}] is missing a valid "title".`
      }
    }
  }

  return null
}
